import catLowerIncisors from "./cat_lower_incisors.svg";
import catUpperIncisors from "./cat_upper_incisors.svg";

const incisors = {
  catLowerIncisors,
  catUpperIncisors,
};

export default incisors;
